import React, { useEffect, useRef, useState } from "react";
import { Button, CheckBox, CheckedImage, Chip, Input } from "../../../common/commonIndex";
import { Image } from "../../../components/componentIndex";
import CancelIcon from "../../../assets/images/doctorProfile/close-icon.svg";


const SearchAllergiesToMedications = ({ handleNextEvent, formData, questionData }) => {
    const [searchAllergies, setSearchAllergies] = useState('');
    const [selectedNoneValue, setSelectedNoneValue] = useState('');
    const [isSetDefault, setIsSetDefault] = useState(false);
    const [isDisabled, setIsDisabled] = useState(false);
    const [isMessagePopup, setIsMessagePopup] = useState(false);
    const [message, setMessage] = useState(null);
    const popupRef = useRef(null);

    const checkData = () => {
        if (questionData?.listOfAnswers?.length === 0) {
            return ['none'];
        }
        let findNone = questionData?.listOfAnswers?.filter(x => x?.answer?.toLowerCase() === 'none')?.length === 0;
        if (findNone) {
            const updatedList = [...questionData?.listOfAnswers, { id: null, fkQuestionId: null, answer: "None" }];
            questionData.listOfAnswers = updatedList;
            return questionData?.listOfAnswers?.map(x => x.answer);
        } else {
            return questionData?.listOfAnswers?.map(x => x.answer);
        }
    }
    const [searchAllergiesList, setSearchAllergiesList] = useState(formData.answer?.length > 0 ? formData.answer :  []);
    const [checkBoxList, setCheckBoxList] = useState(['None', 'aaa']);

    /* Submit */
    const handleSubmit = (e) => {
        e.preventDefault();
        formData.answer = searchAllergiesList;
        if (questionData?.listOfAnswers?.length > 0) {
            let matchingIds = questionData?.listOfAnswers?.filter(answerObj => formData?.answer?.includes(answerObj.answer)).map(answerObj => answerObj.id);
            formData.fkAnswerIds = matchingIds;
        } else {
            formData.fkAnswerIds = searchAllergiesList;
        }
        // skip then 2 otherwise 1
        let skip = 1;
        // if(questionData?.skippedNestedQuestionID){
        //     skip = 2;
        // }
        const findData = getLocalStorageData();
        findData[questionData.questionerIndex] = formData;
        setLocalStorageData(findData);
        handleNextEvent(questionData?.questionerIndex + skip);
    };
    const getLocalStorageData = () => {
        const findlocalStorageData = JSON.parse(localStorage.getItem('listOfAnswer'));
        return findlocalStorageData;
    }
    const setLocalStorageData = (data) => {
        if (data?.length > 0) {
            localStorage.setItem('listOfAnswer', JSON.stringify(data));
        }
    }

    const onChange = (data) => {
        if (data?.toLowerCase() === 'none') {
            setSearchAllergiesList([data]);
        } else {
            let filterAllergiesList = searchAllergiesList?.filter(x => x?.toLowerCase() === 'none');
            if (filterAllergiesList?.length > 0) {
                setSearchAllergiesList([data]);
            } else {
                setSearchAllergiesList([...searchAllergiesList, data]);
            }
        }

        formData.answer = searchAllergiesList;
    }
    /* Callback function to handle radio button change */
    const handleRadioChange = (value) => {
        if (value.toLowerCase() === 'none') {

            setCheckBoxList([value]);
        } else {
            let filterData = checkBoxList.filter(x => x?.toLowerCase() !== 'none');
            if (filterData.includes(value)) {
                // If value is already selected, remove it from the array
                setCheckBoxList(filterData.filter(item => item !== value));
                formData.answer = filterData;
            } else {
                // Otherwise, add the value to the array
                setCheckBoxList([...filterData, value]);
                formData.answer = filterData;
            }
        }

    };

    const handleChipDelete = (chipToDelete) => {
        setSearchAllergiesList((prevList) =>
            prevList.filter((chip) => chip !== chipToDelete)
        );
        if(searchAllergiesList?.length === 1){
            if(searchAllergiesList?.length === 0 || searchAllergiesList[0] === chipToDelete){
                setSelectedNoneValue('');
            }
        }
    };
    const handleSelectDefaultValue = () => {
        setIsDisabled(true);
        setSearchAllergiesList(["None"]); // Clear other selections and add "None"
        setSelectedNoneValue('None');
    };

    // const handleAddMedication = (medication) => {
    //     setIsDisabled(true);
    //     setSearchAllergiesList((prevList) => {
    //         if (prevList.includes("None")) {
    //             return [medication]; // Replace "None" with the new selection
    //         }
    //         return prevList.includes(medication)
    //             ? prevList
    //             : [...prevList, medication]; // Add unique medication
    //     });
    // };
    const openMessagePopup = () => {
        setIsMessagePopup(true);
    };

    const closeMessagePopup = () => {
        setIsMessagePopup(false);
    };
    const handleAddMedication = (medication) => {
        let findSelectedValue;
        if (medication?.length > 0) {
            findSelectedValue = medication?.find(x => x);
        }
        setIsDisabled(true);
        let filterData = findSelectedValue?.toLowerCase() === "none" ? true : searchAllergiesList?.filter(x => x === findSelectedValue)?.length === 0;
        if (filterData) {
            setSearchAllergiesList((prevList) => {
                if (prevList.includes("None")) {
                    return [findSelectedValue]; // Replace "None" with the new selection
                }
                return prevList.includes(findSelectedValue)
                    ? prevList
                    : [...prevList, findSelectedValue]; // Add unique medication
            });
        } else {
            setMessage(`${findSelectedValue} already exists in the list.`);
            openMessagePopup();
            // alert(`${medication[0]} already exists in the list.`);
        }

    };

    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (popupRef.current && !popupRef.current.contains(event.target)) {
                setIsMessagePopup(false);
            }
        };

        document.addEventListener("mousedown", handleOutsideClick);
        return () => {
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    }, [closeMessagePopup]);

    const getChipsList = (searchAllergiesList) => {
        if(searchAllergiesList?.length === 0){return [];}
       const findNoneList = searchAllergiesList?.filter(x => x.toLowerCase() === 'none')?.length === 0;
       if(findNoneList){
        return searchAllergiesList;
       }else{
        return [];
       }
    }

    return (
        <div>
            <h3 className="title">{questionData?.question}</h3>
            <div className="eligibility questionnaire">
                <form>
                    <div>
                        <Chip
                            type={'text'}
                            placeholderName={`Search ${questionData?.question?.toLowerCase()?.includes('medications') ? `medications` : `allergies`} `}
                            list={searchAllergiesList}
                            setSearchMedicationsList={handleAddMedication}
                            setIsSetDefault={setIsSetDefault}
                            setIsDisabled={setIsDisabled}
                            searchList={questionData?.listOfAnswers}
                            selectedNoneValue={selectedNoneValue}
                            onChange={onChange} />
                    </div>
                    {searchAllergiesList?.length > 0 ? (
                        <div
                            className={
                                searchAllergiesList?.length > 15
                                    ? `scrollbar colonoscopy-scrollbar`
                                    : ""
                            }
                        >
                            <div
                                className={
                                    searchAllergiesList?.length > 15
                                        ? `force-overflow`
                                        : ""
                                }
                            >
                                <div className="d-flex flex-wrap justify-content-start align-items-start">
                                    { getChipsList(searchAllergiesList)?.map((chip, index) => (
                                        <div className="me-3" key={index}>
                                            <div className="chips">
                                                <span>{chip} </span>
                                                <span
                                                    className="cursor-pointer"
                                                    onClick={() => handleChipDelete(chip)}
                                                >
                                                    <Image
                                                        imgUrl={CancelIcon}
                                                        altText={""}
                                                        className={"remove"}
                                                    />
                                                </span>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div
                            style={{ width: "51px" }}
                            className={`chips cursor-pointer ${selectedNoneValue ? 'd-none' : ''}`}
                            onClick={handleSelectDefaultValue}
                        >
                            <span>None</span>
                        </div>
                    )}
                    {/* <div className={searchAllergiesList?.length > 15 ? `scrollbar colonoscopy-scrollbar` : ''}>
                        <div className={searchAllergiesList?.length > 15 ? `force-overflow` : ''}>
                            <div className="d-flex flex-wrap justify-content-start align-items-start allergies mt-3">
                                {Array.isArray(searchAllergiesList) && searchAllergiesList.map((item, index) => (
                                    <div key={index}>
                                        <CheckBox
                                            checkBox="gender"
                                            name={item}
                                            id={index}
                                            onCheckBoxChange={handleRadioChange}
                                            formData={formData}
                                            isAllergiesCheck={true}
                                            value={checkBoxList}
                                            setValue={setCheckBoxList}
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div> */}

                </form>
            </div>
            <div className="questionnaire-fix-btn eligibility-fix-btn">
                <div className="divider "></div>
                <div className="footer-content">
                    <div className="skip-eligibility">
                    </div>
                    <Button
                        btnClass={'btn-primary question-btn'}
                        btnType={'button'}
                        btnName={'Continue'}
                        onClick={handleSubmit}
                        isDisabled={true}
                    />
                </div>
            </div>
            {isMessagePopup && (
                <div className="fullscreen-overlay">
                    <div className={`fullscreen-overlay-content alert-fullscreen-overlay alert-popup`} ref={popupRef}>
                        <h2 className={`title mt-5 mb-4`}>
                            {message}
                        </h2>
                        <Button btnClass={`btn-primary`}
                            btnName={'Close'}
                            btnType={'button'}
                            onClick={closeMessagePopup}
                            isDisabled={true}
                        />
                    </div>
                </div>
            )}
        </div>
    )
};

export default SearchAllergiesToMedications;